// extracted by mini-css-extract-plugin
module.exports = {"title":"scholarshipWinnerPage-module--title--iamNu","date":"scholarshipWinnerPage-module--date--ClIiD"};